import TitleTooltip from "./TitleTooltip";
export default function MiembrosMap({user, avatar}) {
    return (
        <TitleTooltip title={user} placement={'top'}>
            <div className={'symbol symbol-35px symbol-circle'}>
                <span className={"symbol-label fw-bold fs-8 " + avatar}>{avatar}</span>
            </div>
        </TitleTooltip>
    );
}
